import { Navigate, Route, Routes } from 'react-router-dom';

import { PERMISSION } from 'src/features/auth/types';
import EventLogTable from 'src/features/eventLog/components/cell/EventLogTable';
import GatewayPassesTable from 'src/features/gatewayPass/components/GatewayPassesTable';
import { PATH } from 'src/features/navigation/utils/constants';
import VisitorsLayout from 'src/features/routes/visitors/VisitorsLayout';
import ActiveStaysTable from 'src/features/stay/components/ActiveStaysTable';
import StayDashboard from 'src/features/stay/components/dashboard/StayDashboard';
import PastStaysTable from 'src/features/stay/components/PastStaysTable';
import { STAY_TYPE } from 'src/features/stay/types';
import VisitorsDashboard from 'src/features/visitor/components/VisitorDashboard';
import VisitorsTable from 'src/features/visitor/components/VisitorsTable';
import useHasPermissions from 'src/hooks/useHasPermissions';

const VisitorsRoutes = () => {
    const accessActiveStays = useHasPermissions([PERMISSION.ACCESS_ACTIVE_STAYS]);
    const accessPastStays = useHasPermissions([PERMISSION.ACCESS_PAST_STAYS]);
    const accessVisitors = useHasPermissions([PERMISSION.ACCESS_VISITORS]);
    const accessEventLog = useHasPermissions([PERMISSION.ACCESS_EVENT_LOGS]);
    const accessGatewayPasses = useHasPermissions([PERMISSION.ACCESS_GATEWAY_PASSES]);

    const defaultRoutePath = (() => {
        if (accessActiveStays) return `/${PATH.VISITORS}/active-stays`;
        if (accessPastStays) return `/${PATH.VISITORS}/past-stays`;
        if (accessVisitors) return `/${PATH.VISITORS}/visitors`;
        if (accessGatewayPasses) return `/${PATH.VISITORS}/gateway-passes`;
        if (accessEventLog) return `/${PATH.VISITORS}/event-log`;

        return '/';
    })();

    return (
        <Routes>
            <Route path="" element={<VisitorsLayout />}>
                <Route index element={<Navigate to={defaultRoutePath} replace />} />
                {accessActiveStays && <Route path="active-stays" element={<ActiveStaysTable />} />}
                {accessPastStays && <Route path="past-stays" element={<PastStaysTable enableSearchParams />} />}
                {accessVisitors && <Route path="visitors" element={<VisitorsTable />} />}
                {accessGatewayPasses && (
                    <Route path="gateway-passes" element={<GatewayPassesTable enableSearchParams />} />
                )}
                {accessEventLog && <Route path="event-log" element={<EventLogTable />} />}
            </Route>

            {accessActiveStays && (
                <Route path="active-stay/dashboard/:stayId" element={<StayDashboard stayType={STAY_TYPE.ACTIVE} />} />
            )}
            {accessPastStays && (
                <Route path="past-stay/dashboard/:stayId" element={<StayDashboard stayType={STAY_TYPE.PAST} />} />
            )}
            {accessVisitors && <Route path="visitor/:visitorId" element={<VisitorsDashboard />} />}
            <Route path="*" element={<Navigate to=".." />} />
        </Routes>
    );
};

export default VisitorsRoutes;
